import { Action } from 'redux';
import { ACTION_TYPE } from '../actionType';
import { IAppState } from '../IAppState';
import { removeError } from './module';
import { AnyAction } from 'redux';


export interface IClearApiErrorAction extends AnyAction {
  apiAction: string;
  requestId: string;
}


/**
 * Makes an action that can be dispatched to clear out a specified API Error from the errors in app state. Dispatching
 * this action when there isn't an error will just leave app state unchanged.
 * @param requestId - The ID of the guest for whom we dispatched the API action
 * @param actionType - The action type for the API action that produced the error you want to clear out.
 */
export const clearApiErrorAction = (requestId: string, actionType: string): IClearApiErrorAction => ({
  type:      ACTION_TYPE.CLEAR_API_ERROR,
  apiAction: actionType,
  requestId: requestId,
});


/**
 * A reducer function that maps ClearApiError actions onto old state to produce new state. If the given error doesn't
 * exist, no explosion happens.
 */
export const clearApiErrorReducer = (state: IAppState, action: Action): IAppState => {
  if (action.type !== ACTION_TYPE.CLEAR_API_ERROR) {
    return state;
  }

  const clearAction = action as IClearApiErrorAction;

  return removeError(state, clearAction.requestId, clearAction.apiAction);
};
